import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'
import { subscribe } from '../utils/pubsub'
import RedAlert from '../ui-elements/RedAlert'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'

type Props = {
    thisCheckPeriod: ObjectStringKeyAnyValue
}



function ManagerSignoffRequired({
    thisCheckPeriod
}: Props) {

    const {
        tableData,
        sendMessageToWebsocket
    } = useContext(GlobalContext)

    const [isBoxChecked, setIsBoxChecked] = useState(false)
    const [noteText, setNoteText] = useState('')


    const [savingProgress, setSavingProgress] = useState(false)

    const signoff = () => {
        // console.log('🚚 toggling....')
        // console.log(thisChecklist)
        if (isBoxChecked) {

            setSavingProgress(true)
            const payload = JSON.stringify({
                action: "checklists",
                subAction: "managerSignoffForCheckPeriod",
                checkPeriodId: thisCheckPeriod['Id'],
                noteText: noteText,
            })
            const unsubscribe = subscribe("tableUpdateItemModified", data => {
                console.log(data)
                if (
                    data.newRecord &&
                    data.newRecord['Id'] &&
                    data.newRecord['Id'] === thisCheckPeriod['Id']
                ) {
                    setSavingProgress(false)
                    unsubscribe()
                }
            })
            sendMessageToWebsocket(payload)
        }
    }


    if (savingProgress) {
        return <div className={`w-full flex flex-row items-center justify-between gap-4 rounded border bg-yellow-100 border-yellow-500 text-yellow-700 px-3 py-2`}>
            <Spinner>Saving...</Spinner>
        </div>
    }


    return <div className={`w-full flex flex-row items-center justify-between gap-4 rounded border bg-yellow-100 border-yellow-500 text-yellow-700 px-3 py-2`}>

        {/* <img src={'/tip-icon.png'} className={`w-12 h-12`} alt={`Tip icon`} /> */}

        <div className={`text-4xl`}>✍️</div>

        <div className={`flex-1 flex flex-col items-start gap-2`}>
            <p className={`font-bold text-lg`}>Manager signoff required</p>

            <label className={`flex flex-row items-center gap-2`}>
                <input
                    type={'checkbox'}
                    className={`w-4 h-6`}
                    checked={isBoxChecked}
                    onChange={(e) => { setIsBoxChecked(e.target.checked) }}
                />
                I have reviewed the answers for this check period
            </label>
            <div className={`w-full flex flex-col gap-1`}>
                <p className={`text-sm text-gray-600`}>Notes:</p>
                <input
                    type={'text'}
                    className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                    value={noteText}
                    onChange={(e) => { setNoteText(e.target.value) }}
                />
            </div>

            <Button
                onClick={signoff}
                text={`Sign off`}
                fullwidth={false}
                disabled={isBoxChecked ? false : true}
                variant={isBoxChecked ? 'primary' : 'gray'}

            />
        </div>

    </div>

}
export default ManagerSignoffRequired